import {
  getAuditStatus,
  getBroadCastList,
  getAppletQRCode,
  getPoster,
  getJsSdkSignature,
} from '@/apis/activity/common';
import mobileType from './mobileType';
import util from '@/utils/util';
import wx from 'weixin-js-sdk';

export default {
  //各平台带过来的参数及初始值定义获取返回
  getPlatFromParams(query) {
    let paramsMR = {
      areaCode: '110000',
      channel: '1020000000',
      // deviceId: util.getUUID(),
      platform: null,
      softVersion: '4.7.8',
      sysVersion: 'TNY-AL00,10',
      token: '',
    };
    let paramsData = {};
    if (+query.platform == 4) {
      paramsMR.platform = 4;
      let cityCode = +(paramsMR.areaCode.slice(0, 4) + '00');
      let { platform, ...paramsOther } = query;//过滤对象中data属性
      paramsData = {
        params: paramsMR,//公参
        paramsOther: util.filterParams({
          cityCode,
          ...paramsOther
        }),
      };
      return paramsData;
    } else {
      if (query.data) {
        let params = decodeURIComponent(query.data);
        let parseParams = JSON.parse(params);
        if (+parseParams.platform == 3) {
          let paramss = { ...paramsMR, ...parseParams };
          let areaCode = paramss.areaCode;
          let cityCode = +(areaCode.slice(0, 4) + '00');
          let { data, ...paramsOther } = query;//过滤对象中data属性
          paramsData = {
            params: paramss,//公参
            paramsOther: util.filterParams({
              cityCode,
              ...paramsOther
            }),
          };
          return paramsData;
        }
      }
    }
  },
  //APP交互处理
  getUserInfoFromApp() {
    let params = {
      methodName: 'getDataFromNative',//定义与原生的方法名(固定)
      type: 1,//业务类型(固定)
    };
    if (mobileType.isIOS()) {
      //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
      window.webkit.messageHandlers.getDataFromVue.postMessage(params);
    } else if (mobileType.isAndroid()) {
      //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
      window.Android.getDataFromVue(JSON.stringify(params));
    } else {
    }
  },
  getParamsIosAndroid(params, query) {
    let paramsData = {};
    let PS = {};
    if (mobileType.isIOS()) {
      PS = params;
    } else if (mobileType.isAndroid()) {
      PS = JSON.parse(params);
    }
    let areaCode = PS.areaCode;
    let cityCode = +(areaCode.slice(0, 4) + '00');
    let { data, ...paramsOther } = query;//过滤对象中data属性
    let paramsD = query.data ? JSON.parse(decodeURIComponent(query.data)) : {};
    paramsData = {
      params: PS,//公参
      paramsOther: util.filterParams({
        cityCode,
        ...paramsOther,
        ...paramsD
      }),
    };
    return paramsData;
  },
  //客户端分享处理
  pushShareFun(params) {
    if (mobileType.isIOS()) {
      //vue调用iOS方法，且传值给iOS （iOS 方法名为 getDataFromVue）
      window.webkit.messageHandlers.wsShare.postMessage(params);
    } else if (mobileType.isAndroid()) {
      //vue调用Android方法，且传值给Android （Android方法名为 getDataFromVue）
      window.ws.wsShare(JSON.stringify(params));
    } else {
      alert('平台判断错误');
    }
  },
  //获取当前定位
  getPosition() {
    const citySearch = new window.AMap.CitySearch();
    citySearch.getLocalCity(function (status, result) {
      if (status === 'complete' && result.info === 'OK') {
        console.log(result, '当前位置'); //result包括很多种状态，表示城市码的为adcode
        return result;
      } else {
        console.log('获取失败');
      }
    });
  },
  //APP交互处理params
  getParams(params) {
    if (mobileType.isIOS()) {
      return params;
    } else if (mobileType.isAndroid()) {
      return JSON.parse(params);
    }
  },
  // 获取用户认证状态
  async getAuditStatusFun(obj) {
    let params = {
      channel: obj.channel,
      deviceId: obj.deviceId,
      platform: obj.platform,
      softVersion: obj.softVersion,
      sysVersion: obj.sysVersion,
      token: obj.token,
    };
    params.data = JSON.stringify(params.data);
    try {
      const data = await getAuditStatus(params);
      if (data.code == 1) {
        console.log(JSON.parse(data.data), '用户认证状态');
        return JSON.parse(data.data);
      } else {
        this.$toast(data.msg);
      }
    } catch (error) {
    }
  },
  // 获取活动播报信息
  async getBroadCastListFun(obj, activityId, activityType) {
    let params = {
      channel: obj.channel,
      deviceId: obj.deviceId,
      platform: obj.platform,
      softVersion: obj.softVersion,
      sysVersion: obj.sysVersion,
      token: obj.token,
      data: {
        activityId: activityId,
        activityType: activityType,
      },
    };
    params.data = JSON.stringify(params.data);
    try {
      const data = await getBroadCastList(params);
      if (data.code == 1) {
        return JSON.parse(data.data);
      } else {
        this.$toast(data.msg);
      }
    } catch (error) {
    }
  },
  // 获取小程序太阳码
  async getAppletQRCodeFun(obj, QRCodeObj) {
    let params = {
      channel: obj.channel,
      deviceId: obj.deviceId,
      platform: obj.platform,
      softVersion: obj.softVersion,
      sysVersion: obj.sysVersion,
      token: obj.token,
      data: {
        scene: QRCodeObj.scene,//生成小程序码 所带自定义参数 （例如 "userId=1"）最大32个可见字符，只支持数字，大小写英文以及部分特殊字符
        page: QRCodeObj.page,//必须是已经发布的小程序存在的页面（否则报错），例如 pages/index/index, 根路径前不要填加 /,不能携带参数（参数请放在scene字段里），如果不填写这个字段，默认跳主页面
        width: QRCodeObj.width,//二维码的宽度，单位 px，最小 280px，最大 1280px
        autoColor: QRCodeObj.autoColor,//自动配置线条颜色，如果颜色依然是黑色，则说明不建议配置主色调，默认 false
        lineColor: QRCodeObj.lineColor,//线条颜色rgb json auto_color 为 false 时生效，使用 rgb 设置颜色 例如 {"r":0,"g":0,"b":0} 十进制表示
        isHyaline: QRCodeObj.isHyaline,//是否透明背景 默认为false
      },
    };
    params.data = JSON.stringify(params.data);
    try {
      const data = await getAppletQRCode(params);
      if (data.code == 1) {
        return JSON.parse(data.data).cdnUrl;
      } else {
        this.$toast(data.msg);
      }
    } catch (error) {
    }
  },
  // 生成海报
  async getPosterFun(obj, posterObj) {
    let params = {
      channel: obj.channel,
      deviceId: obj.deviceId,
      platform: obj.platform,
      softVersion: obj.softVersion,
      sysVersion: obj.sysVersion,
      token: obj.token,
      data: {
        bgUrl: posterObj.bgUrl,//背景图url----------------必须
        qrCodeUrl: posterObj.qrCodeUrl,//小程序码url----------------必须
        imgWidth: posterObj.imgWidth,//小程序码在背景图上的宽度 默认175
        imgHeight: posterObj.imgHeight,//小程序码在背景图上的高度 默认175
        locationX: posterObj.locationX,//小程序码距背景图左边线的距离----------------必须
        locationY: posterObj.locationY,//小程序码距背景图上边线的距离----------------必须
      },
    };
    params.data = JSON.stringify(params.data);
    try {
      const data = await getPoster(params);
      if (data.code == 1) {
        return JSON.parse(data.data).url;
      } else {
        this.$toast(data.msg);
      }
    } catch (error) {
    }
  },
  // 获取JsSdk签名
  async getJsSdkSignatureFun(param, sharePlatformList) {
    let params = { ...param };
    params.data = util.filterParams({
      url: window.location.href
    });
    params.data = JSON.stringify(params.data);
    try {
      const data = await getJsSdkSignature(params);
      if (data.code == 1) {
        let datas = JSON.parse(data.data);
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: datas.appId, // 必填，公众号的唯一标识
          timestamp: datas.timestamp, // 必填，生成签名的时间戳
          nonceStr: datas.nonceStr, // 必填，生成签名的随机串
          signature: datas.signature,// 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });
        wx.ready(function () {      //需在用户可能点击分享按钮前就先调用
          wx.updateAppMessageShareData({
            title: sharePlatformList.title, // 分享标题
            desc: sharePlatformList.description, // 分享描述
            link: sharePlatformList.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePlatformList.imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          });
          wx.updateTimelineShareData({
            title: sharePlatformList.title, // 分享标题
            link: sharePlatformList.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: sharePlatformList.imgUrl, // 分享图标
            success: function () {
              // 设置成功
            }
          });
        });
      } else {
        this.$toast(data.msg);
      }
    } catch (error) {
    }
  },
};
